import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import NumberUtilities from "../../../../../utilities/NumberUilities";

export default class MiejscowosciForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nazwa: '',
            sz: '',
            dl: '',
            validatorMessages: []
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeNazwa = this.onChangeNazwa.bind(this)
        this.onChangeSzerokosc = this.onChangeSzerokosc.bind(this)
        this.onChangeDlugosc = this.onChangeDlugosc.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.miejscowosc)) {
            this.setState({
                nazwa: this.props.miejscowosc.nazMi,
                sz: this.props.miejscowosc.szGps,
                dl: this.props.miejscowosc.dlGps,
            })
            document.getElementById('nazwaInput').value = this.props.miejscowosc.nazMi;
            document.getElementById('szerokoscInput').value = this.props.miejscowosc.szGps;
            document.getElementById('dlugoscInput').value = this.props.miejscowosc.dlGps;
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.miejscowosc) {
            this.setState({
                nazwa: nextprops.miejscowosc.nazMi,
                sz: nextprops.miejscowosc.szGps,
                dl: nextprops.miejscowosc.dlGps,
            })
            document.getElementById('nazwaInput').value = nextprops.miejscowosc.nazMi;
            document.getElementById('szerokoscInput').value = nextprops.miejscowosc.szGps;
            document.getElementById('dlugoscInput').value = nextprops.miejscowosc.dlGps;
        }
    }


    onChangeNazwa(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 30, 'nazwaInput', this.state.nazwa)) {
            this.setState({nazwa: e.target.value})
        }
    }

    onChangeSzerokosc(e) {
        this.setState({sz: e.target.value})
    }

    onChangeDlugosc(e) {
        this.setState({dl: e.target.value})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        this.setState({validatorMessages: []})

        let poprawne = true; this.state.validatorMessages = [];

        if (this.state.nazwa.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nazwa nie jest uzupełniona')

        }
        if (Boolean(this.state.sz)){
            if (!Validator.validateIntOrDouble(this.state.sz) || !Validator.validateSzerokoscDlugoscWysokoscGeo(this.state.sz, 'sz')) {

                poprawne = false;
                this.dodajDoValidatorMessages('Szerokość geograficzna jest niepoprawna')
            }
        }

        if (Boolean(this.state.dl)){
            if ((!Validator.validateIntOrDouble(this.state.dl) || !Validator.validateSzerokoscDlugoscWysokoscGeo(this.state.dl, 'dl'))) {
                poprawne = false;
                this.dodajDoValidatorMessages('Długość geograficzna jest niepoprawna')
            }
        }

        if(poprawne){
            this.setState({validatorMessages: []})

            let data = {
                "nazMi": this.state.nazwa,
                "szGps": Boolean(this.state.sz)?NumberUtilities.parseStringToNumber(this.state.sz):null,
                "dlGps":  Boolean(this.state.dl)?NumberUtilities.parseStringToNumber(this.state.dl):null,
            }

            this.props.handleClickZapisz(data, Boolean(this.props.miejscowosc))
        }
    }


    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.miejscowosc) ? 'Edycja miejscowości' : 'Nowa miejscowość'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <ControlLabel>
                                    Nazwa miejscowości <span className={'req'}>*</span>  <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nazwa.length}/30 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeNazwa}
                                             id={'nazwaInput'}/>
                            </Col>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Szerokość geo.
                                </ControlLabel>
                                <FormControl onChange={this.onChangeSzerokosc}
                                             id={'szerokoscInput'} type={'number'}/>
                            </Col>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Długość geo.
                                </ControlLabel>
                                <FormControl onChange={this.onChangeDlugosc}
                                             id={'dlugoscInput'} type={'number'}/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={3}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonCancel onClick={() => {
                                    this.props.handleClickAnuluj()
                                }} text={'Anuluj'}/>
                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/miejscowosci/components/MiejscowosciForm.js